import type { MarketConfig } from '../../types';

export const qmLandingPageConfig = {
  slug: 'aca-de-qm',
  label: 'QM-LandingPage Deutschland',
  country: 'DE',
  language: 'de',
  siteSection: 'AKD',
  cms: 'Unbounce',
  title: 'Qualitaetsmanagement Seminare | TÜV SÜD Akademie',
  description:
    'Deutsche Landingpage fuer Qualitaetsmanagement-Weiterbildungen, ISO 9001 Trainings und praxisnahe QM-Kompetenzentwicklung der TÜV SÜD Akademie.',
  themeColor: '#0046ad',
  ogImage: 'https://mango-grass-0099f4103.6.azurestaticapps.net/favicon.png',
  ogImageAlt: 'TÜV SÜD Akademie Qualitaetsmanagement Landingpage',
  twitterCard: 'summary_large_image',
  robots: 'noindex,nofollow',
} satisfies MarketConfig;
